import { render } from "./InventorySideMenu.vue?vue&type=template&id=2f64d07d&scoped=true"
import script from "./InventorySideMenu.vue?vue&type=script&lang=js"
export * from "./InventorySideMenu.vue?vue&type=script&lang=js"

import "./InventorySideMenu.vue?vue&type=style&index=0&id=2f64d07d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f64d07d"]])

export default __exports__